var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"file_drag",attrs:{"draggable":_vm.draggable},on:{"dragstart":_vm.drag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }